import script from "./fittingValue.vue?vue&type=script&setup=true&lang=js"
export * from "./fittingValue.vue?vue&type=script&setup=true&lang=js"

import "./fittingValue.vue?vue&type=style&index=0&id=6f0ef3e6&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0ef3e6"]])

export default __exports__